export default __webpack_public_path__ + "static/media/whitebulb.7e3cbbba.jpeg";